/* Yummy Gummy — PDP "Users audio reviews" players.
   Native <audio>, custom controls: click play/pause; a live timer counts up;
   a 1x/1.5x/2x speed toggle; the waveform's played portion fills via a
   --pdp-ar-progress custom property. Only one review plays at a time — starting
   one pauses the others. Safe & idempotent; guarded so a missing piece no-ops. */
(function () {
  'use strict';

  var SPEEDS = [1, 1.5, 2];

  function fmt(t) {
    if (!isFinite(t) || t < 0) t = 0;
    var m = Math.floor(t / 60);
    var s = Math.floor(t % 60);
    return m + ':' + (s < 10 ? '0' : '') + s;
  }

  function initList(list) {
    if (!list || list.__pdpArBound) return;
    list.__pdpArBound = true;

    var cards = Array.prototype.slice.call(list.querySelectorAll('[data-pdp-ar-card]'));
    var scrollers = Array.prototype.slice.call(list.querySelectorAll('.pdp-ar__scroller'));

    function pauseOthers(except) {
      cards.forEach(function (card) {
        if (card === except) return;
        var a = card.querySelector('[data-pdp-ar-audio]');
        if (a && !a.paused) a.pause();
      });
    }

    // Freeze ONLY the row whose audio is playing (per request) — the other row
    // keeps scrolling. Each scroller checks whether any audio INSIDE its own
    // row is currently playing.
    function syncMarquee() {
      scrollers.forEach(function (s) {
        var row = s.closest('.pdp-ar__row') || s;
        var playingInRow = Array.prototype.some.call(
          row.querySelectorAll('[data-pdp-ar-audio]'),
          function (a) { return !a.paused && !a.ended; }
        );
        s.style.animationPlayState = playingInRow ? 'paused' : '';
      });
    }

    cards.forEach(function (card) {
      var audio = card.querySelector('[data-pdp-ar-audio]');
      var playBtn = card.querySelector('[data-pdp-ar-play]');
      var wave = card.querySelector('[data-pdp-ar-wave]');
      var bars = wave ? Array.prototype.slice.call(wave.querySelectorAll('.pdp-ar__bar')) : [];
      var timeEl = card.querySelector('[data-pdp-ar-time]');
      var speedBtn = card.querySelector('[data-pdp-ar-speed]');
      if (!audio || !playBtn) return;

      var speedIdx = 0;

      function setProgress() {
        var ratio = audio.duration ? audio.currentTime / audio.duration : 0;
        // Colour the bars up to the play position teal (.is-filled) — only the
        // waveform fills, not the whole card.
        if (bars.length) {
          var filled = Math.round(ratio * bars.length);
          bars.forEach(function (b, i) { b.classList.toggle('is-filled', i < filled); });
        }
        if (timeEl) {
          // Show elapsed while playing/seeked; total duration at rest/start.
          timeEl.textContent = (audio.paused && audio.currentTime === 0 && audio.duration)
            ? fmt(audio.duration)
            : fmt(audio.currentTime);
        }
      }

      audio.addEventListener('loadedmetadata', function () {
        if (timeEl && audio.paused) timeEl.textContent = fmt(audio.duration);
      });
      audio.addEventListener('timeupdate', setProgress);
      audio.addEventListener('play', function () {
        card.classList.add('is-playing');
        playBtn.setAttribute('aria-label', 'Pause audio review');
        syncMarquee();
      });
      audio.addEventListener('pause', function () {
        card.classList.remove('is-playing');
        playBtn.setAttribute('aria-label', 'Play audio review');
        syncMarquee();
      });
      audio.addEventListener('ended', function () {
        card.classList.remove('is-playing');
        audio.currentTime = 0;
        setProgress();
        syncMarquee();
      });

      playBtn.addEventListener('click', function () {
        if (audio.paused) {
          pauseOthers(card);
          var p = audio.play();
          if (p && typeof p.catch === 'function') p.catch(function () {});
        } else {
          audio.pause();
        }
      });

      // Seek by clicking along the waveform.
      if (wave) {
        wave.addEventListener('click', function (e) {
          if (!audio.duration) return;
          var rect = wave.getBoundingClientRect();
          var ratio = Math.min(Math.max((e.clientX - rect.left) / rect.width, 0), 1);
          audio.currentTime = ratio * audio.duration;
          setProgress();
        });
      }

      if (speedBtn) {
        speedBtn.textContent = SPEEDS[speedIdx] + 'x';
        speedBtn.addEventListener('click', function () {
          speedIdx = (speedIdx + 1) % SPEEDS.length;
          audio.playbackRate = SPEEDS[speedIdx];
          speedBtn.textContent = SPEEDS[speedIdx] + 'x';
        });
      }
    });
  }

  function init(root) {
    (root || document).querySelectorAll('[data-pdp-ar-list]').forEach(initList);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
